import { AxiosResponse } from 'axios';
import { get } from 'lodash';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { syncEntitiesAndGetResults } from '../entities/entities.sagas';
import SCHEMA from '../schema';
import { createKpiDocumentsApi } from '../utils/api.utils';
import { runSagaWithAuth } from '../utils/api.utils';
import {
  KpiDocumentsActionTypes,
  FETCH_KPI_DOCUMENTS_API_REQUESTED,
  fetchKpiDocumentsSuccess,
  fetchKpiDocumentsFailed,
  FETCH_KPI_DOCUMENTS_STORE_KEY,
} from './kpi-document.actions';
import { SearchKpiDocumentResultsDTO, KpiDocumentApi } from '@reposit/api-client';
import { FetchKpiDocumentsPayload } from './kpi-document.types';
import { getKpiDocumentsPagination } from './kpi-document.selectors';
import { FlashMessagesActionTypes, setFlashMessage } from '../flash-messages/flash-messages.actions';
import { FlashState } from '../../components/FlashMessage';
import { getErrorMessage } from '../../utils/common.utils';

export const KPI_DOCUMENTS_PAGE_SIZE = 10;

// ****************
// WORKERS
// ****************

export function* fetchKpiDocuments({ payload }: { type: string; payload: FetchKpiDocumentsPayload }) {
  try {
    const kpiDocumentsApi: KpiDocumentApi = yield createKpiDocumentsApi();
    const pagination = yield select(getKpiDocumentsPagination);
    const apiResponse: AxiosResponse<SearchKpiDocumentResultsDTO> = yield call(
      runSagaWithAuth(() =>
        kpiDocumentsApi.searchKpiDocuments(payload.date, payload.date, pagination.page, KPI_DOCUMENTS_PAGE_SIZE)
      )
    );

    const ids: string[] = yield syncEntitiesAndGetResults(apiResponse.data.results, SCHEMA.kpiDocuments);

    yield put<KpiDocumentsActionTypes>(fetchKpiDocumentsSuccess(apiResponse.data.count, ids));
    yield put<FlashMessagesActionTypes>(
      setFlashMessage({
        key: FETCH_KPI_DOCUMENTS_STORE_KEY,
        message: `Success! Fetched KPI Documents for ${payload.date}`,
        state: FlashState.SUCCESS,
      })
    );
  } catch (e) {
    const error = getErrorMessage(e);
    yield put<KpiDocumentsActionTypes>(fetchKpiDocumentsFailed(get(e, 'response.data.message', e)));
    yield put<FlashMessagesActionTypes>(
      setFlashMessage({
        key: FETCH_KPI_DOCUMENTS_STORE_KEY,
        message: error,
        state: FlashState.ERROR,
      })
    );
  }
}

// ****************
// WATCHERS
// ****************
export function* watchKpiDocumentSagas() {
  yield takeLatest(FETCH_KPI_DOCUMENTS_API_REQUESTED, fetchKpiDocuments);
}
